/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FoodSourceDto } from '../../models/food-source-dto';
import { NotificationMessage } from '../../models/notification-message';

export interface ApiFoodsourcePost$Params {
  'api-version'?: string;
      body?: FoodSourceDto
}

export function apiFoodsourcePost(http: HttpClient, rootUrl: string, params?: ApiFoodsourcePost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
  const rb = new RequestBuilder(rootUrl, apiFoodsourcePost.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationMessage>;
    })
  );
}

apiFoodsourcePost.PATH = '/api/foodsource';
